import { createQuery, queryClient } from '../common';
import * as apis from '../apis';

export const QUERY_KEY_FUNNEL_ANALYSES = `/gm/v1/funnel_analyses` as const;

export const useFunnelAnalyses = createQuery({
  queryKey: [QUERY_KEY_FUNNEL_ANALYSES],
  queryFn: apis.getFunnelAnalyses,
  staleTime: 0,
});

export const useFunnelAnalysis = createQuery((id: string) => ({
  queryKey: [QUERY_KEY_FUNNEL_ANALYSES, id],
  queryFn: () => apis.getFunnelAnalysis(id),
  enabled: !!id,
  cacheTime: Infinity,
  staleTime: Infinity,
}));

export const useAssociatedFunnelAnalyses = createQuery(
  (type: 'critical_events' | 'dimensions', id: string) => ({
    queryKey: [`/gm/v1/${type}/${id}/funnel_analyses`],
    queryFn: () =>
      type === 'critical_events'
        ? apis.getCriticalEventAssociatedFunnelAnalyses(id)
        : apis.getDimensionAssociatedFunnelAnalyses(id),
    staleTime: 0,
    cacheTime: 0,
  }),
);

export const updateFunnelAnalysisCache = (
  id: string,
  data: Parameters<typeof apis.postFunnelAnalysis>[0],
) => {
  const queryKey = [QUERY_KEY_FUNNEL_ANALYSES, id];
  const current = queryClient.getQueryData<DataOf<typeof useFunnelAnalysis>>(queryKey);

  if (!current) return;

  queryClient.setQueryData(queryKey, {
    ...current,
    config: {
      ...data,
      critical_events_detail: current.config.critical_events_detail,
    },
  });
};

export const invalidateFunnelAnalysisQuery = (id: string) => {
  void queryClient.invalidateQueries({
    queryKey: [QUERY_KEY_FUNNEL_ANALYSES, id],
  });
};

export const removeFunnelAnalysisQuery = (id: string) => {
  queryClient.removeQueries({
    queryKey: [QUERY_KEY_FUNNEL_ANALYSES, id],
  });
};
